interface ISales {
  isMessage: boolean;
  isSendRequest: boolean;
  isDirect: boolean;
  isDirectAndInstallment: boolean;
}

export const SaleMethodMap: Record<number, keyof ISales> = {
  1: 'isMessage', // پیام
  2: 'isSendRequest', //  ارسال درخواست
  3: 'isDirect', // خرید نقدی
  4: 'isDirectAndInstallment', // خرید اقساطی و خرید نقدی
};

// a helper function that accepts an array of numbers and returns the type of shops sale method
export const SaleMethodChoices = (salesTypesData: number[]): ISales => {
  if (!salesTypesData) {
    return {
      isMessage: false,
      isSendRequest: false,
      isDirect: false,
      isDirectAndInstallment: false,
    };
  }

  return salesTypesData.reduce<ISales>(
    (acc, type) => {
      const key = SaleMethodMap[type];
      if (key) acc[key] = true;
      return acc;
    },
    {
      isMessage: false,
      isSendRequest: false,
      isDirect: false,
      isDirectAndInstallment: false,
    },
  );
};
